import React from 'react';
import { LINKS } from '../../constants/LinksConstants';
import '../ContactUs/ContactUs.scss';
import Nav from '../NavBar';
import Footer from '../ContactUsFooter';
import ContactUsBackground from './ContactUsBackground';
import ContactUsContent from './ContactUsContent';


class ContactUs extends React.Component {
    constructor(props) {
        super(props);
    this.urls = {
            JoinUs : 'https://www.sixt.jobs/en',
            Blog: 'https://medium.com/the-sixt-india-blog'
          }
    this.state = {
        navItems: [
          
          {
            id: 'Blog',
            label: 'BLOG',
            hideIndex: true
          },
          {
            id: 'JoinUs',
            label: 'JOIN US',
            hideIndex: true
          }
        ],
        headerBackgroundClass:'header',
        Footer:[
            {
                label: "Privacy Policy",
                link: "https://about.sixt.com/websites/sixt_cc/English/8100/privacy-policy.html"
              },
              {
                label: "SIXT JOBS",
                link: "https://www.sixt.jobs/en"
              },
              {
                label: "Blogs",
                link: "https://medium.com/the-sixt-india-blog"
              },
              {
                label: "Contact Us",
                link: "/contact-us"
              }
          ]
      };
     
    }

    
      headerBackground = () => {
    
    
        if(document.documentElement.scrollTop > 50)
        {
         this.setState({headerBackgroundClass:'headerActive'});
        }
        else{
          this.setState({headerBackgroundClass:'header'});
        }
          
      }
      componentDidMount(){
        window.addEventListener("scroll",this.headerBackground);
      }
      
      componentWillUnmount(){
        window.removeEventListener("scroll", this.headerBackground);
      }
    setActiveNavItem = item_id => {
    //  const { navItems } = this.state;
  
      if ((Object.keys(this.urls)||[]).includes(item_id)) {
        // Redirect to links here
        window.open(this.urls[item_id],'_blank');
      } else {
        document.getElementById(item_id).scrollIntoView({behavior: "smooth"})
      }
    };
  
    render() {
      const { navItems } = this.state;
      const { pageData } = this.state;

    return(
        
    <div className="contactUs">
      <ContactUsBackground/>
        <div className='contactUsMain'>
            <div className='nav-wrapper'>
          <Nav items={navItems}
            setActiveItem={this.setActiveNavItem} />
        </div>
        <div className={this.state.headerBackgroundClass}>
          <a href ='/'>
        <div className="logo-container">
            <div className="logo" />
            <div>
                <span className="logo-research">Research</span>
                <span className="logo-development"> & Development</span>
            </div>
        </div>
        </a>
        <div class="blog-join-us">
            <a class="blog-txt" href="https://medium.com/the-sixt-india-blog" target="_blank" rel="noopener noreferrer" >
                BLOG
            </a>
            <a class="join-us-btn" href={LINKS.website} target="_blank" rel="noopener noreferrer" >
                JOIN US
            </a>
        </div>
        </div>
      <ContactUsContent/>
        </div>
        <div class="mapouter">
            <div class="gmap_canvas">
                <iframe title="Sixt India Location" id="gmap_canvas" src="https://maps.google.com/maps?q=sixt&t=&z=13&ie=UTF8&iwloc=&output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
                <a href="https://www.embedgooglemap.org">proper way embed google map</a>
            </div>
        </div>
        <Footer links={pageData} />
    </div>)
}
};
export default ContactUs;